import {
    trigger,
    state,
    style,
    animate,
    transition
} from "@angular/animations";

export const slideXParentMenu = trigger("parentMenuState", [
    transition(":enter", [
        style({
            opacity: 0,
            transform: "translateX(-260px)"
        }),
        animate(
            "200ms cubic-bezier(0.0, 0.0, 0.2, 1)",
            style({
                opacity: 1,
                transform: "translateX(0px)"
            })
        )
    ]),
    transition(":leave", [
        animate(
            "100ms cubic-bezier(0.4, 0.0, 1, 1)",
            style({
                opacity: 0,
                transform: "translateX(-260px)"
            })
        )
    ])
]);

export const slideXSubMenu = trigger("subMenuState", [
    transition(":enter", [
        style({
            opacity: 0,
            transform: "translateX(260px)"
        }),
        animate(
            "200ms cubic-bezier(0.0, 0.0, 0.2, 1)",
            style({
                opacity: 1,
                transform: "translateX(0px)"
            })
        )
    ]),
    transition(":leave", [
        animate(
            "100ms cubic-bezier(0.4, 0.0, 1, 1)",
            style({
                opacity: 0,
                transform: "translateX(260px)"
            })
        )
    ])
]);
